import { apiClientHooks } from "../../bootstrapping/InitApiClient"
import { useProfileAssured } from "../../bootstrapping/InitRequireProfile"
import { useSelectedCustomer } from "../../routes/CustomerSelector"
import { getCustomerRole } from "../../logic/caseWorkerRole"

export { getCustomerRole } from "../../logic/caseWorkerRole"
export type { CustomerRole } from "../../logic/caseWorkerRole"

/**
 * Role + case-worker feature availability for the currently selected customer.
 * caseWorkersEnabled is undefined while the customer record loads.
 * selfEmployedAllowed (DBS-320) is likewise undefined while it loads, so the invite form can wait
 * for the real answer before choosing its default (DBS-328).
 */
export const useCaseWorkerContext = () => {
  const profile = useProfileAssured()
  const selectedCustomer = useSelectedCustomer()
  const customerId = selectedCustomer?.customer_id

  const getCustomerById = apiClientHooks.useGetCustomerById({
    params: { id: customerId ?? '' },
  }, {
    enabled: !!customerId,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })

  const role = getCustomerRole(profile, customerId)

  return {
    customerId,
    myProfileId: profile.id,
    role,
    isCaseWorker: role === 'case_worker',
    isManagerOrStaff: role === 'manager' || role === 'staff',
    caseWorkersEnabled: getCustomerById.data == null ? undefined : getCustomerById.data.customer_managed_case_workers === true,
    selfEmployedAllowed: getCustomerById.data == null ? undefined : getCustomerById.data.allow_self_employed_applications === true,
  }
}
